import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div``;

const StyledHeadContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 70px;
	background: linear-gradient(
		90deg,
		rgba(255, 255, 255, 0) 0%,
		rgba(255, 255, 255, 0.05) 50.48%,
		rgba(255, 255, 255, 0) 100%
	);

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledHeadBackground = styled.div`
	position: absolute;
	width: 100%;
	height: 70px;
	left: 0;
	top: 0;
	border-bottom: 1px solid #ffffff;
	mask-image: linear-gradient(
		90deg,
		rgba(255, 255, 255, 0) 0%,
		rgba(255, 255, 255, 0.05) 50.48%,
		rgba(255, 255, 255, 0) 100%
	);
	mask-size: 100% 100%;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: linear-gradient(
		90deg,
		rgba(255, 255, 255, 0) 0%,
		rgba(255, 255, 255, 0.05) 50.48%,
		rgba(255, 255, 255, 0) 100%
	);
	-webkit-mask-size: 100% 100%;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
`;

const StyledDescription = styled(Text)`
	font-size: 14px;
	text-align: center;
	color: #ffffff;
	opacity: 0.5;
	max-width: 530px;
	height: 32px;
	margin: 30px auto 0;
`;

const StyledCraftContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 77px;
`;

const StyledItemsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 80px);
	gap: 20px;
	margin-top: 20px;
`;

const StyledItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 9px;

	.arrow {
		width: 16px;
		height: 8px;
		opacity: 0.1;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 80px;
	height: 80px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
`;

const StyledCountContainer = styled.div<{ $red?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 80px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: ${({ $red }) => ($red ? '#FF3D3D' : '#FFFFFF')};

		span {
			color: #ffffff;
			opacity: 0.5;
		}
	}
`;

const StyledCountSliderContainer = styled.div`
	margin-top: 30px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	img {
		width: 16px;
		height: 16px;
	}
`;

export {
	StyledButtonContent,
	StyledContainer,
	StyledCountContainer,
	StyledCountSliderContainer,
	StyledCraftContainer,
	StyledDescription,
	StyledHeadBackground,
	StyledHeadContainer,
	StyledItem,
	StyledItemContainer,
	StyledItemsGrid,
};
